import React from 'react'
import Modal from 'react-bootstrap/Modal'
import { AssumptionModalBody, ModalButton } from '../../styles/ComponentStyles'


const AssumptionsModal = ({ assumptionsModalIsOpen, closeAssumptionsModal, calculationData }) => {
    const { unitPrice, co2UK, exportPrice, currency = 'GBP' } = calculationData;
    const priceUnit = currency === 'EUR' ? 'c/kWh' : 'p/kWh';


    return (
        <Modal
            show={assumptionsModalIsOpen}
            onHide={closeAssumptionsModal}
            backdrop="static"
            size="lg"
            centered
            scrollable
            contentClassName='background'
        >
            <Modal.Header>
                <Modal.Title>How your estimate is calculated</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AssumptionModalBody>
                    <h2>Calculation method</h2>
                    <p>This calculator estimates the performance of domestic solar photovoltaic (PV) systems. Its calculations are based on the local amounts of solar radiation (sunlight) for your postcode, as well as your roof's compass direction, its slope angle, and any shading affecting it. This calculator is designed to provide a simple estimate for those who haven't installed a PV system yet, and the calculations should not be considered a guarantee of performance. Your actual fuel bill savings will depend on a number of factors, including the efficiency and location of your PV system and how much electricity you use during the hours that the system is generating.</p>
                    <p>System output (kWh/year) is calculated as: system size (kWp) × irradiance correction factor × shading factor.</p>
                    <p>The irradiance correction factor comes from region-specific KK tables, which map your postcode to a UK solar irradiance region and hold correction factors indexed by roof slope angle and compass direction (measured as the angle from south). A steeper south-facing roof with no shading will have a higher factor, and therefore a higher estimated output, than a shallow, shaded, or north-facing roof.</p>
                    <p>The shading factor reduces the estimate to account for nearby obstructions (such as trees or buildings) that block direct sunlight for part of the day.</p>
                    <p>Generation uses the selected system size and local irradiance factor, with the selected shading factor applied. No additional 15% system-loss deduction is applied.</p>
                    {unitPrice ? (<>
                        <h2>Financial Assumptions</h2>
                        <p>The cost of a unit of electricity is {unitPrice} {priceUnit} at the moment (updated regularly)</p>
                        <p>The payment for a unit of exported electricity is {exportPrice} {priceUnit} at the moment (updated regularly)</p>
                        <h2>Energy Usage Assumptions</h2>
                        <p>Self-consumption uses the annual electricity consumption entered for this estimate. Base self-consumption is capped at 60%; selected battery capacity adds an estimated uplift, with total self-consumption capped at 90%.</p>
                        <p>Simple payback is the final installation price divided by first-year bill savings and export income. Break-even is the first year cumulative benefit covers the installation price, with generation reducing by 0.4% each year over 25 years. Electricity tariffs are held constant.</p>
                        <h2>CO2 Saving Assumptions</h2>
                        <p>The amount of CO2 released by a kWh of grid electricity is {co2UK}kg</p></>) : (<p>Pricing and CO2 figures will appear here once your estimate has been calculated.</p>)}
                    <h2>Ground mounted system</h2>
                    <p>For any ground mounted system the compass bearing and panel slope are assumed to be at the optimum values.</p>
                </AssumptionModalBody>
            </Modal.Body>
            <Modal.Footer>
                <ModalButton onClick={closeAssumptionsModal}>Close</ModalButton>
            </Modal.Footer>
        </Modal>
    )
}

export default AssumptionsModal
